import { Box, Chip, Divider, Grid } from '@mui/material';
import { getStatusLabel } from 'src/Utils/Combined';
import PdfAndImageView from 'src/components/pdfAndImageView/PdfAndImageView';
import { useState } from 'react';
import { CommonTypoGraphy } from 'src/components/pdfAndImageView/CommonTypoGraphy';
import OfflinePaymentCardInformation from '../../subModules/invoice/singleInvoice/OfflinePaymentCardInformation';
import { Link } from 'react-router-dom';
import CommonDetailItem, {
  formatDate,
  formatValue,
} from 'src/components/CommonDetailItem/CommonDetailItem';

const labelWidth = { xs: '130px', sm: '150px', md: '170px' };

const IdCardInfo = ({ singleIdCard }: any) => {
  const [imageViewOpen, SetImageViewOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>('');

  if (!singleIdCard) return null;

  const companyNameView = singleIdCard?.user_member_company_name ? (
    <Box
      component={singleIdCard?.user_member_id ? Link : 'span'}
      to={
        singleIdCard?.user_member_id
          ? `/member-list/${singleIdCard.user_member_id}`
          : undefined
      }
      sx={{
        display: 'inline-block',
        px: 1.5,
        py: 0.5,
        borderRadius: '6px',
        fontWeight: 700,
        fontSize: '0.95rem',
        color: (theme) =>
          theme.palette.mode === 'dark' ? '#90caf9' : 'primary.main',
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark'
            ? 'rgba(144, 202, 249, 0.16)'
            : '#e3f2fd',
        border: '1px solid',
        borderColor: (theme) =>
          theme.palette.mode === 'dark'
            ? 'rgba(144, 202, 249, 0.3)'
            : '#90caf9',
        textDecoration: 'none',
        '&:hover': singleIdCard?.user_member_id
          ? {
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark'
                  ? 'rgba(144, 202, 249, 0.28)'
                  : '#bbdefb',
            }
          : {},
      }}
    >
      {singleIdCard.user_member_company_name}
    </Box>
  ) : (
    'N/A'
  );

  const photoView = singleIdCard.photo ? (
    <CommonTypoGraphy
      name='View Photo'
      onClick={() => {
        SetImageViewOpen(true);
        setImageFile(singleIdCard.photo);
      }}
    />
  ) : (
    'N/A'
  );

  const dobDate = formatDate(singleIdCard.date_of_birth, 'MMM Do YYYY');

  const websiteLink = singleIdCard.website ? (
    <a
      href={
        singleIdCard.website.startsWith('http')
          ? singleIdCard.website
          : `https://${singleIdCard.website}`
      }
      target='_blank'
      rel='noopener noreferrer'
    >
      {singleIdCard.website}
    </a>
  ) : (
    'N/A'
  );

  const tinFileView = singleIdCard.tin_file ? (
    <CommonTypoGraphy
      name='View TIN Certificate'
      onClick={() => {
        SetImageViewOpen(true);
        setImageFile(singleIdCard.tin_file);
      }}
    />
  ) : (
    'N/A'
  );

  const tradeLicenseView = singleIdCard.trade_license_file ? (
    <CommonTypoGraphy
      name='View Trade license'
      onClick={() => {
        SetImageViewOpen(true);
        setImageFile(singleIdCard.trade_license_file);
      }}
    />
  ) : (
    'N/A'
  );

  const civilAviationView =
    singleIdCard.civil_aviation_renewed_certificate_file ? (
      <CommonTypoGraphy
        name='View Civil Aviation Certificate'
        onClick={() => {
          SetImageViewOpen(true);
          setImageFile(singleIdCard.civil_aviation_renewed_certificate_file);
        }}
      />
    ) : (
      'N/A'
    );

  const signatureView = singleIdCard.signature_file ? (
    <CommonTypoGraphy
      name='View Signature'
      onClick={() => {
        SetImageViewOpen(true);
        setImageFile(singleIdCard.signature_file);
      }}
    />
  ) : (
    'N/A'
  );

  const specimenSignatureView = singleIdCard.specimen_signature_file ? (
    <CommonTypoGraphy
      name='View Specimen signature'
      onClick={() => {
        SetImageViewOpen(true);
        setImageFile(singleIdCard.specimen_signature_file);
      }}
    />
  ) : (
    'N/A'
  );

  const statusLabel = singleIdCard.status
    ? getStatusLabel(singleIdCard.status)
    : 'N/A';

  return (
    <>
      <Grid container spacing={2} pt={2}>
        <CommonDetailItem
          label='Company Name'
          value={companyNameView}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Applicant Name'
          value={formatValue(singleIdCard.applicant_name)}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Designation'
          value={formatValue(singleIdCard.designation)}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Status'
          value={statusLabel}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Photo'
          value={photoView}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Date of Birth'
          value={dobDate}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Telephone'
          value={formatValue(singleIdCard.telephone)}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Cellphone'
          value={formatValue(singleIdCard.cellphone)}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Fax Number'
          value={formatValue(singleIdCard.fax)}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Email'
          value={formatValue(singleIdCard.email)}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Blood Group'
          value={formatValue(singleIdCard.blood_group)}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Website'
          value={websiteLink}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='TIN Number'
          value={formatValue(singleIdCard.tin_number)}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='TIN Certificate'
          value={tinFileView}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Trade License'
          value={tradeLicenseView}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Civil Aviation Cert'
          value={civilAviationView}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Signature'
          value={signatureView}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />
        <CommonDetailItem
          label='Specimen Sig'
          value={specimenSignatureView}
          labelWidth={labelWidth}
          xs={12}
          sm={6}
          md={4}
        />

        {singleIdCard?.paymentInfo && (
          <Grid item xs={12} mt={2}>
            <Divider
              sx={{ position: 'relative', justifyContent: 'space-between' }}
            >
              <Chip label='Payment Information' size='small' color='primary' />
              <Link
                to={`/invoices/transactions/${singleIdCard?.paymentInfo?.invoice_id}`}
              >
                <Chip
                  label='Go Invoice'
                  size='small'
                  sx={{ position: 'absolute', right: 0, background: '#D7E9FD' }}
                />
              </Link>
            </Divider>

            <OfflinePaymentCardInformation data={singleIdCard?.paymentInfo} />
          </Grid>
        )}
      </Grid>

      <PdfAndImageView
        setOpen={SetImageViewOpen}
        open={imageViewOpen}
        file={imageFile}
      />
    </>
  );
};

export default IdCardInfo;
